import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import AccountHeader from "../components/AccountHeader";
import SwitchUserDropdown from "../components/SwitchUserDropdown";
import SettingsList from "../components/SettingsList";
import addressIcon from "../assets/Addresses_Icon.svg";
import creditCardIcon from "../assets/Credit_Card_Icon_Circle.svg";
import dreamStreamIcon from "../assets/DreamStream_Icon.svg";
import emergencyContactIcon from "../assets/Emergency_Contact_Icon.svg";
import topicsIcon from "../assets/Topics_Icon (1).svg";
import taxesIcon from "../assets/Taxes_Icon.svg";
import homeSiteIcon from "../assets/HomeSite_Icon.svg";
import managementIcon from "../assets/WWG_News_Icon.svg";
import membershipIcon from "../assets/Membership_Icon.svg";
import personalIcon from "../assets/Personal_Icon.svg";
import platinumSettings from "../assets/Sub_Entity_Icon.svg";
import privacyIcon from "../assets/Privacy_Icon.svg";
import applistIcon from "../assets/App_List_Icon.svg";
import notificationIcon from "../assets/Notifications_Icon.svg";
import wwgNewsIcon from "../assets/WWG_News_Icon.svg";
import alertIcon from "assets/alert_square_icon.svg";
import messageIcon from "assets/Communication_Setting_Icon.png";
import languageIcon from "../assets/LanguageSetting_Icon.svg";
import PageFooter from "../components/PageFooter";
import styles from "./HomePage.module.css";
import { capitalizeName } from "components/shared/capitalizeName";
import { useAccount, useIssues } from "../utils/AccountInfoContext";
import AccountIssueBanner from "components/AccountIssueBanner";
import mobile from "mobileBridge";
import Cookies from "js-cookie";
import environment from "../environment";

export function HomePage() {
  const history = useHistory();
  const {
    accountData,
    activeUser,
    setActiveUserInfo,
    usersData,
    issuesData,
    iboLOAData,
    billingData,
    nagScreenData,
    privacyData,
    consentData,
    directToTCPage,
    setDirectToTCPage,
    directToSubEntityNagScreen,
    setDirectToSubEntityNagScreen,
    directToVerifyNagScreen,
    setDirectToVerifyNagScreen,
    directToConsentNagScreen,
    setDirectToConsentNagScreen,
    setStoredUserId,
  } = useAccount();

  const WEB_APP_COUNTRY = environment?.WEB_APP_COUNTRY;
  const isANZ = WEB_APP_COUNTRY === "AU";

  const filteredIssues = (issuesData || []).filter((item) => {
    if (isANZ && item.Type === "membership-primary-billing-ach-missing") {
      return false;
    }
    return true;
  });

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    // Check if any issue includes the term "unverified"
    const hasUnverifiedIssue = issuesData?.some(
      (issue) =>
        issue?.Type === "email-unverified" || issue?.Type === "phone-unverified"
    );

    if (
      consentData &&
      privacyData &&
      privacyData.agreedLatest === false &&
      directToTCPage
    ) {
      history.push("/tc");
      setAllToNotDirect();
    } else if (
      nagScreenData &&
      nagScreenData.length > 0 &&
      directToSubEntityNagScreen
    ) {
      history.push("/sub-entity-alert");
      setAllToNotDirect();
      // }
      // else if (hasUnverifiedIssue && directToVerifyNagScreen && !isANZ) {
      //   history.push("/verify");
      //   setAllToNotDirect();
    } else if (
      consentData &&
      consentData.consent_provided &&
      consentData.consent_provided.toLowerCase() === "no" &&
      directToConsentNagScreen
    ) {
      history.push("/consent");
      setAllToNotDirect();
    }
  }, [
    consentData,
    directToConsentNagScreen,
    nagScreenData,
    privacyData,
    issuesData,
    directToSubEntityNagScreen,
    directToVerifyNagScreen,
    directToTCPage,
    history,
  ]);

  const setAllToNotDirect = () => {
    setDirectToTCPage(false);
    setDirectToSubEntityNagScreen(false);
    setDirectToVerifyNagScreen(false);
    setDirectToConsentNagScreen(false);
  };

  const handleSaveUser = (user) => {
    const newUser = {
      ...user,
      iboNum: accountData.account.ibo,
      iboLOAInfo: user.iboLOAInfo,
      accountIssues: user.accountIssues,
    };

    setActiveUserInfo(newUser);
    Cookies.set("community-user-id", user.userId);
    // refetchIssueData(user.userId);

    closeDropdown();
  };

  const totalIssues = issuesData ? issuesData.length : 0;

  const openDropdown = () => {
    if (contactCount < 2) {
      return;
    }
    if (mobile.isApp()) {
      const users = usersData.map((user) => {
        const contact = accountData.contacts.find(
          (c) => c.contactId === user.contactId
        );

        return {
          userId: user.userId,
          contactId: user.contactId,
          name: `${contact?.firstName || user.strFirst} ${
            contact?.lastName || user.strLast
          }`,
        };
      });

      mobile
        .postMessage("change-user-native", users, true)
        .then((selectedUser) => {
          const userData = users.filter((o) => o.userId === selectedUser);

          const newUser = userData.map((user) => {
            const [strFirst, strLast] = user.name.split(" ");

            const contact = accountData.contacts.find(
              (c) => c.contactId === user.contactId
            );
            return {
              ...user,
              ...contact,
              firstName: contact?.firstName || strFirst,
              lastName: contact?.lastName || strLast,
              iboNum: accountData.account.ibo,
              iboLOAInfo: iboLOAData,
              accountIssues: issuesData,
            };
          });
          setStoredUserId(null);
          setActiveUserInfo(newUser[0]);
        });
    } else {
      setIsDropdownOpen(!isDropdownOpen);
    }
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const handleLogout = () => {
    // setActiveUserInfo(null);
    mobile.postMessage("native-logout", false);
  };

  const handleOnViewIssues = () => {
    history.push("/account-issues");
  };
  const contactCount = accountData?.contacts?.length;

  return (
    <div className={styles.container}>
      {(totalIssues > 0 || (!consentData && !isANZ)) && (
        <AccountIssueBanner onClick={handleOnViewIssues} />
      )}
      <AccountHeader
        onClick={openDropdown}
        activeUser={activeUser?.name || ""}
        iboNum={activeUser?.iboNum}
        currentPage="homepage"
        contactCount={contactCount}
      />
      {isDropdownOpen && (
        <SwitchUserDropdown
          users={usersData.map((user) => {
            const contact = accountData.contacts.find(
              (c) => c.contactId === user.contactId
            );
            return {
              ...user,
              ...contact,
              firstName: contact?.firstName || user.strFirst,
              lastName: contact?.lastName || user.strLast,
              iboNum: accountData.account.ibo,
              iboLOAInfo: iboLOAData,
              accountIssues: issuesData,
            };
          })}
          onSave={handleSaveUser}
          activeUser={activeUser}
          // refetchIssues={refetchIssueData}
          isPersonalPage={false}
        />
      )}

      <div className={styles.content}>
        <SettingsList items={items} issuesCount={filteredIssues.length} />
      </div>
      <div className={styles.footer}>
        <PageFooter onClick={handleLogout} />
      </div>
    </div>
  );
}

export default HomePage;

const items = [
  {
    icon: alertIcon,
    label: "Account Issues",
  },
  {
    icon: addressIcon,
    label: "Addresses",
  },
  {
    icon: messageIcon,
    label: "Communication",
  },
  {
    icon: creditCardIcon,
    label: "Credit Cards",
  },
  {
    icon: dreamStreamIcon,
    label: "DreamStream",
  },
  {
    icon: emergencyContactIcon,
    label: "Emergency Contacts",
  },
  {
    icon: languageIcon,
    label: "Language",
  },
  // {
  //   icon: taxesIcon,
  //   label: "GST & HST Taxes",
  // },
  {
    icon: homeSiteIcon,
    label: "HomeSite",
  },
  {
    icon: managementIcon,
    label: "Management Team",
  },
  {
    icon: membershipIcon,
    label: "Membership",
  },
  {
    icon: personalIcon,
    label: "Personal",
  },
  {
    icon: platinumSettings,
    label: "Platinum Settings",
  },
  // {
  //   icon: privacyIcon,
  //   label: "Privacy",
  // },
  {
    icon: wwgNewsIcon,
    label: "WWG News",
  },
  {
    icon: applistIcon,
    label: "App List Settings",
  },
  {
    icon: notificationIcon,
    label: "Notification Settings",
  },
  {
    icon: topicsIcon,
    label: "Topics",
  },
];
